// Row types for supabase/migrations/001_init.sql. Keep them in sync with the migration.

/** Public profile columns. date_of_birth isn't readable through the API. */
export interface Profile {
  id: string;
  username: string;
  display_name: string | null;
  avatar_url: string | null;
  banner_url: string | null;
  bio: string | null;
  is_creator: boolean;
  created_at: string;
  updated_at: string;
}

/** Columns a user may change on their own profile (column-level UPDATE grant). */
export type ProfileUpdate = Partial<Pick<Profile, 'username' | 'display_name' | 'bio'>> // avatar and banner are set by the studio API only (migration 007);

export interface Video {
  id: string;
  creator_id: string;
  title: string;
  description: string | null;
  video_url: string;
  thumbnail_url: string;
  duration: string | null;
  category: string;
  is_vip_only: boolean;
  views: number;
  created_at: string;
}

export interface Membership {
  id: string;
  user_id: string;
  creator_id: string;
  tier: 'supporter' | 'vip';
  status: 'active' | 'canceled' | 'past_due';
  expires_at: string | null;
  created_at: string;
}

export const PROFILE_COLUMNS = 'id, username, display_name, avatar_url, banner_url, bio, is_creator, created_at, updated_at';
